import {classListIdForShow} from '@/utils/showClassList'

// SHO-429: the Entry Types screen -- a table of entry types grouped by group, each with the shows that use it (shows.entry_details_id) and the class list each show is on.

function byText (a, b) {
  const x = (a || '').toString().toLowerCase()
  const y = (b || '').toString().toLowerCase()
  return x < y ? -1 : x > y ? 1 : 0
}

// Shows by date, then name. A show without a date sorts last.
function byShowDateThenName (a, b) {
  if (a.show_date && b.show_date && a.show_date !== b.show_date) return a.show_date < b.show_date ? -1 : 1
  if (a.show_date && !b.show_date) return -1
  if (!a.show_date && b.show_date) return 1
  return byText(a.name, b.name)
}

// [{show, listId, ownList}] -- ownList: the show is on a list other than the entry type's default
function showRows (shows, type, event) {
  return shows.slice().sort(byShowDateThenName).map(show => {
    const listId = classListIdForShow(show, event)
    return {show, listId, ownList: !!(type && listId && type.class_list_id && listId !== type.class_list_id)}
  })
}

// The shows of one entry type, by date then name
export function entryTypeShowRows (type, event) {
  if (!type) return []
  const shows = ((event && event.shows) || []).filter(s => s.entry_details_id === type.event_show_type_id)
  return showRows(shows, type, event)
}

// Shows whose entry type isn't in entryTypes (none, or a deleted type)
export function orphanShowRows (entryTypes, event) {
  const ids = new Set((entryTypes || []).map(t => t.event_show_type_id))
  const shows = ((event && event.shows) || []).filter(s => !ids.has(s.entry_details_id))
  return showRows(shows, null, event)
}

// The exhibitor's New Entry dropdown lists entry types in the DB's order: get_event_show_types
// does `order by group_type, label` under the en_US.UTF-8 collation, which ignores case, spaces and
// punctuation, then breaks ties lowercase first, then the shorter name first; no group sorts last.
// Matches the DB for every event (7,524 events checked 2026-10-14).
const baseCollator = new Intl.Collator('en-US', {sensitivity: 'base', ignorePunctuation: true})
const caseCollator = new Intl.Collator('en-US', {sensitivity: 'variant', ignorePunctuation: true, caseFirst: 'lower'})
function byDbText (a, b) {
  const noA = a === null || a === undefined
  const noB = b === null || b === undefined
  if (noA || noB) return noA && noB ? 0 : noA ? 1 : -1
  a = a.toString()
  b = b.toString()
  return baseCollator.compare(a, b) || caseCollator.compare(a, b) || (a.length - b.length) || (a < b ? 1 : a > b ? -1 : 0)
}

// Entry types in New Entry dropdown order: group, then label
export function compareEntryTypes (a, b) {
  return byDbText(a.group_type, b.group_type) || byDbText(a.label, b.label)
}

// The table's rows, grouped: [{group, types: [{type, shows}]}], in New Entry dropdown order.
// Entry types without a group come last, under group ''.
export function entryTypeGroupRows (entryTypes, event) {
  const groups = []
  ;(entryTypes || []).slice()
    .sort(compareEntryTypes)
    .forEach(type => {
      const name = type.group_type || ''
      let group = groups.find(g => g.group === name)
      if (!group) {
        group = {group: name, types: []}
        groups.push(group)
      }
      group.types.push({type, shows: entryTypeShowRows(type, event)})
    })
  return groups
}

// Entry type dropdown options under group headings, in table order:
// [{header: true, label: group, key}, type, type, {header: true, ...}, ...]. Headers aren't selectable.
export function entryTypeOptionsByGroup (entryTypes) {
  const options = []
  entryTypeGroupRows(entryTypes, null).forEach(g => {
    options.push({header: true, label: g.group || 'NO GROUP', key: `__group:${g.group}`})
    g.types.forEach(t => options.push(t.type))
  })
  return options
}
